import { useState } from "react";
import Head from "next/head";
import useUser from "../../lib/useUser";
import withSession from "../../lib/session";
import { Layout } from "../../common/Layout";
import { Container, Grid, Button } from "@mui/material";
import { gql, request } from "graphql-request";

import { Book } from "../../common/Book";

export default function BookCreate() {
  if (typeof window === "undefined") {
    // breaks the initial rendering of the sx prop for the MainType box...not entirely sure why
    return null;
  }

  return (
    <Layout>
      <Container>
        <Book />
      </Container>
    </Layout>
  );
}

// export const getServerSideProps = withSession(async function ({ req, res }) {
//   const user = req.session.get("user") || null;

//   return {
//     props: { user },
//   };
// });
